var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import { css, jsx } from "@emotion/react";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { filterAttributes } from "../utils";
import * as defaultStyles from "./RuledList.module.css";
RuledList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  gap: PropTypes.number,
  ruleBottom: PropTypes.bool,
  ruleTop: PropTypes.bool,
  styles: PropTypes.objectOf(PropTypes.string)
};
export default function RuledList(_a) {
  var _b = _a,
    {
      children,
      className,
      gap,
      ruleBottom,
      ruleTop,
      styles = defaultStyles
    } = _b,
    restProps = __objRest(_b, ["children", "className", "gap", "ruleBottom", "ruleTop", "styles"]);
  let attributes = filterAttributes(restProps);
  let childCount = React.Children.count(children);
  return /* @__PURE__ */jsx("ul", __spreadValues({
    css: css({
      "--list-gap": gap
    }),
    className: clsx(styles.list, ruleTop && styles.ruleTop, ruleBottom && styles.ruleBottom, className)
  }, attributes), React.Children.map(children, (child, index) => {
    return /* @__PURE__ */jsx("li", {
      className: clsx(styles.item, ruleTop && index === 0 && styles.ruleTop, ruleBottom && index === childCount - 1 && styles.ruleBottom)
    }, child);
  }));
}